/**
 * ミツカン試食室 TOPページ JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
  setTastingProducts();
});

/**
 * HTML特殊文字をエスケープする（XSS防止）
 */
function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * 試食室商品一覧を読み込む
 */
async function setTastingProducts() {
  try {
    const response = await fetch(`${window.AppProxyPath}/api/customers/tasting-reviews/released-products`, {
      method: 'get',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    const products = result.products;
    const container = document.getElementById('js-tasting-product-list');
    const comingSoon = document.getElementById('js-tasting-coming-soon');

    if (!container) return;

    if (!products || products.length === 0) {
      if (comingSoon) comingSoon.hidden = false;
      return;
    }

    // テンプレートが存在するかチェック
    const templateEl = document.getElementById('js-product-card-template');
    if (!templateEl) {
      console.error('Template element not found');
      return;
    }

    const template = templateEl.innerHTML;
    let html = '';

    // TypeSquare用：追加されたテキストを収集
    let allNewText = '';

    // メタオブジェクト mizkan_tasting_sort の並びでソート（#2124）
    // ソートリストに含まれない handle は末尾に回す
    const sortHandles = Array.isArray(window.TASTING_SORT_HANDLES) ? window.TASTING_SORT_HANDLES : [];
    const sortedProducts = [...products].sort((a, b) => {
      const ia = sortHandles.indexOf(a.monitor_handle);
      const ib = sortHandles.indexOf(b.monitor_handle);
      if (ia === -1 && ib === -1) return 0;
      if (ia === -1) return 1;
      if (ib === -1) return -1;
      return ia - ib;
    });

    // 免責文HTML（一番上の商品のみ表示・#2123）
    const aiNoteHtml = '<p class="tasting-room-product-card__ai-note">※「みんなの声まとめ」は、お客さまの投稿をAIで要約したもので、株式会社Mizkanの見解や正確性を保証するものではありません。（詳細は<a href="https://www.mizkan.co.jp/product/" target="_blank" rel="noopener noreferrer">商品情報</a>をご確認ください。）</p>';

    sortedProducts.forEach((product, index) => {
      // テキストを収集（TypeSquare用）
      if (product.name) allNewText += ' ' + product.name;
      if (product.ai_summary) allNewText += ' ' + product.ai_summary;

      let itemHtml = template;
      // 必須項目の置換（テキストコンテンツはXSS防止のためエスケープ）
      itemHtml = itemHtml.replace(/\[\[name\]\]/g, escapeHtml(product.name || ''));
      itemHtml = itemHtml.replace(/\[\[url\]\]/g, product.monitor_handle ? `/pages/mizkan-tasting-release/${product.monitor_handle}` : '#');
      itemHtml = itemHtml.replace(/\[\[average_rating\]\]/g, product.average_rating || 0);
      itemHtml = itemHtml.replace(/\[\[review_count\]\]/g, product.review_count || 0);
      itemHtml = itemHtml.replace(/\[\[ai_summary\]\]/g, escapeHtml(product.ai_summary || ''));

      // 画像URLの置換 (data-src用)
      const imageUrl = product.image_url || '';
      itemHtml = itemHtml.replace(/\[\[image_url\]\]/g, imageUrl);

      // 免責は1件目のみ
      itemHtml = itemHtml.replace(/\[\[ai_note\]\]/g, index === 0 ? aiNoteHtml : '');

      html += itemHtml;
    });

    container.innerHTML = html;

    // 画像のロード処理
    // image_urlがある場合のみsrcを上書きする
    const images = container.querySelectorAll('img[data-src]');
    images.forEach(img => {
      const dataSrc = img.getAttribute('data-src');
      if (dataSrc && dataSrc !== '') {
        img.src = dataSrc;
      }
    });

    // 星レーティングの初期化
    if (typeof window.initStarRatings === 'function') {
      window.initStarRatings();
    }

    // AI要約の「もっと見る」トグル初期化
    initSummaryToggles();

    allNewText += ' ※「みんなの声まとめ」は、お客さまの投稿をAIで要約したもので、株式会社Mizkanの見解や正確性を保証するものではありません。（詳細は商品情報をご確認ください。）';

  } catch (error) {
    console.error('API error:', error);
    // エラー時のフォールバックやローディング解除などがあればここに記述
    const loading = document.querySelector('#loading_suchan');
    if (loading) loading.classList.remove('is_loading');
  } finally {
    const loading = document.getElementById('js-tasting-loading');
    if (loading) loading.classList.remove('is-loading');
  }
}

/**
 * AI要約テキストの「もっと見る」トグル初期化
 * 4行を超える場合に折りたたみ表示する
 */
function initSummaryToggles() {
  const summaryCards = document.querySelectorAll('.tasting-room-product-card__summary');

  summaryCards.forEach(function(summary) {
    const content = summary.querySelector('.tasting-room-product-card__summary-full');
    const toggleWrap = summary.querySelector('.tasting-room-product-card__summary-toggle-wrap');

    if (!content || !toggleWrap) return;

    // 実際のline-heightから4行分の高さを計算
    const computedStyle = window.getComputedStyle(content);
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const limitHeight = lineHeight * 4;

    const realHeight = content.scrollHeight;

    if (realHeight > limitHeight) {
      content.classList.add('is-collapsed');
      content.style.height = limitHeight + 'px';
      toggleWrap.classList.add('show');
    }

    toggleWrap.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (content.classList.contains('is-collapsed')) {
        content.classList.remove('is-collapsed');
        content.style.height = 'auto';
        toggleWrap.classList.remove('show');
      }
    });
  });
}
